import styled from 'styled-components';
import logo from '~/assets/images/bank/logo.svg';
import { Text } from '~/components/ui/Text';
import bg from '../../assets/images/bank_start_bg.png';

const StyledContainer = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 17, 17, 0.98);
	background-image: url(${bg});
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;

	transition: opacity 0.3s;
	opacity: 1;

	&.start-enter {
		opacity: 0;
	}

	&.start-enter-active,
	&.start-enter-done,
	&.start-exit {
		opacity: 1;
	}

	&.start-exit-active {
		opacity: 0;
	}
`;

const StyledLogo = styled.div<{ $top?: boolean }>`
	position: absolute;
	top: ${({ $top }) => ($top ? '84px' : '50%')};
	left: 50%;
	transform: ${({ $top }) =>
		$top ? 'translate(-50%, 0)' : 'translate(-50%, -50%)'};
	width: ${({ $top }) => ($top ? '30px' : '44px')};
	height: ${({ $top }) => ($top ? '40px' : '60px')};
	background-image: url(${logo});
	background-size: contain;
	background-position: center;
	background-repeat: no-repeat;
	transition:
		top 0.3s ease,
		transform 0.3s ease,
		width 0.3s ease,
		height 0.3s ease;
`;

const StyledPincodeContainer = styled.div<{ $show?: boolean }>`
	position: absolute;
	top: 256px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 40px;
	opacity: ${({ $show }) => ($show ? 1 : 0)};
	transition: opacity 0.3s ease;

	${Text} {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledPincodeDotsContainer = styled.div<{ $length?: number }>`
	display: grid;
	grid-template-columns: repeat(${({ $length }) => $length}, 20px);
	gap: 40px;
`;

const StyledPincodeDot = styled.div<{ $active?: boolean; $error?: boolean }>`
	width: 20px;
	height: 20px;
	background-color: ${({ $active, $error }) =>
		$error ? '#EF3124' : $active ? '#FFFFFF' : 'rgba(255, 255, 255, 0.1)'};
	border-radius: 20px;
	transition: background-color 0.3s ease;
`;

const StyledPincodeInput = styled.input`
	visibility: hidden;
	user-select: none;
	pointer-events: none;
`;

const StyledTimerContainer = styled.div<{ $show?: boolean }>`
	position: absolute;
	top: 374px;
	left: 50%;
	transform: translate(-50%, 0);
	height: 30px;
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 0 8px;
	border-radius: 10px;
	background-color: #ef3124;
	opacity: ${({ $show }) => ($show ? 1 : 0)};
	transition: opacity 0.3s ease;

	img {
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		width: 40px;
		font-size: 14px;
		color: #ffffff;
	}
`;

const StyledErrorText = styled(Text)`
	position: absolute;
	top: 228px;
	left: 50%;
	transform: translateX(-50%);
	font-weight: 400;
	font-size: 16px;
	line-height: 18px;
	color: #ef3124;
`;

export {
	StyledContainer,
	StyledErrorText,
	StyledLogo,
	StyledPincodeContainer,
	StyledPincodeDot,
	StyledPincodeDotsContainer,
	StyledPincodeInput,
	StyledTimerContainer,
};
